const TIME_ZONE = "Pacific/Auckland";

const timeFormatter = new Intl.DateTimeFormat("en", { hour: "numeric", minute: "numeric", hour12: true, timeZone: TIME_ZONE });
const dayFormatter = new Intl.DateTimeFormat("en-NZ", { timeZone: TIME_ZONE });
const shortDateFormatter = new Intl.DateTimeFormat("en-NZ", { weekday: "short", day: "numeric", month: "short", timeZone: TIME_ZONE });

export const formatTime = (date: Date): string => timeFormatter.format(date);

export const formatDay = (date: Date): string => dayFormatter.format(date);

export const formatShortDate = (date: Date): string => shortDateFormatter.format(date);
